import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export default ({
  radius,
  ...props
}: Omit<IContentLoaderProps, 'height'> & {
  height: number | string;
  radius?: number | string;
}) => (
  <ContentLoader width="100%" speed={2} {...props}>
    <rect
      x="0"
      y="0"
      rx={radius || '3'}
      ry={radius || '3'}
      width="100%"
      height={props.height}
    />
  </ContentLoader>
);
